export const GLOBAL_CONSTANTS = {
	CODE_SUCCESS: 1,
	MSG_SUCCESS: "success",
	HTTP_STATUS_SUCCESS: 200,
}